import React from 'react'

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24">
    <path d="M22.584 0L24 1.414L13.415 12L24 22.582L22.586 24L12 13.414L1.414 24L0 22.582L10.584 11.999L0 1.414L1.416 0L12 10.583L22.584 0Z" />
  </svg>
)

export default CloseIcon
